/**
 * Dependencies:
 *  - jQuery
 */

const BookingForm = {

    init: () => {
		document.querySelectorAll('a[href^="tel:"]').forEach(element => {
			element.href = element.href.replaceAll(/[\s()]/g, '');
		});
    }

}

export default BookingForm;
